export const linearGradient = ([from, to]: string[]) => `
background: linear-gradient(to right, ${from} 50%, ${to} 50%);
`
